import React from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { Typography } from '@mui/material'
import GuidanceNote from '../../../components/GuidanceNote'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
  UI_COLOR_PRIMARY_HOVER,
  UI_COLOR_SURFACE_INFO,
  UI_COLOR_TEXT_INFO,
  UI_COLOR_TEXT_NEUTRAL
} from '../../../constants/uiColors'

const VARIANT_STYLES = {
  info: {
    icon: <InfoOutlinedIcon />,
    accentColor: UI_COLOR_PRIMARY_HOVER,
    backgroundColor: UI_COLOR_SURFACE_INFO,
    textColor: UI_COLOR_TEXT_INFO
  },
  warning: {
    icon: <WarningAmberOutlinedIcon />,
    accentColor: UI_COLOR_ACCENT_ORANGE,
    backgroundColor: UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
    textColor: UI_COLOR_TEXT_NEUTRAL
  }
}

export default function ScheduleSummaryAlert({ content, sx = {} }) {
  if (!content?.parts?.length) return null

  const variant = VARIANT_STYLES[content.severity] || VARIANT_STYLES.info

  return (
    <GuidanceNote
      title=""
      icon={variant.icon}
      accentColor={variant.accentColor}
      backgroundColor={variant.backgroundColor}
      textColor={variant.textColor}
      singleLine
      sx={{ mt: 2, width: '100%', ...sx }}
      titleSx={{ display: 'none' }}
      messageSx={{ flex: '1 1 auto', minWidth: 0 }}
      message={
        <Typography
          component="span"
          sx={{ fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' }}
        >
          {content.parts.map((part, index) =>
            part.bold ? (
              <Typography
                key={`${part.text}-${index}`}
                component="span"
                sx={{ fontWeight: 700, fontSize: 'inherit', lineHeight: 'inherit' }}
              >
                {part.text}
              </Typography>
            ) : (
              <React.Fragment key={`${part.text}-${index}`}>{part.text}</React.Fragment>
            )
          )}
        </Typography>
      }
    />
  )
}
